import { render, staticRenderFns } from "./AreaEmbargadaSigaMtPonto.vue?vue&type=template&id=0e6a4313&lang=pug"
import script from "./AreaEmbargadaSigaMtPonto.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaSigaMtPonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports